var is_marketing_img = 0;
var marketing_index = setInterval(function () {
  try {
    let iframeDoc = document.getElementById("automizely_marketing_popup_bars").contentDocument;
    if (iframeDoc.querySelector("#modal-content1")) {
      iframeDoc.querySelector(
        "#modal-content1  div.mars41.mars45 > span"
      ).style = `text-align: center;
  color: #fff;
  display: block;
  margin-bottom: 0rem!important;
  white-space: pre-line;
  font-weight: 800!important;`;

      
      
       let img_html = `
      <img loading="lazy1" src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/945faa1be3d6552354f80ff6e166a048_f23bfc53-15a9-4159-969a-845769b644d1.jpg?v=1788244268" style="
    width: 100%;
    margin-bottom: 10px;
    margin-top: -10px;
">`;
      if(!is_marketing_img){
      iframeDoc
        .querySelector("#modal-content1  form")
        .insertAdjacentHTML("beforebegin", img_html);
        is_marketing_img = 1;
      }
      
      let m_bottom = '15%';
      if(window.innerWidth < 375){
        m_bottom = '5%';
      }else if(window.innerWidth >= 375 && window.innerWIdth<414){
        m_bottom = '10%';
      }
      if(isMobile){
         iframeDoc.querySelector(".MuiPaper-root").style.marginBottom = m_bottom;
      }
      iframeDoc.querySelector(
        ".customPreviewModal-0-0-3 .MuiPaper-root"
      ).style.maxHeight = isMobile?"560px":"960px";
      // iframeDoc.querySelector(
      //   "#modal-content1 > div:nth-child(3) > div > div.mars46.mars54.mars57.mars47.mars63 > div:nth-child(1)"
      // ).style.marginTop = "5px";
      $(".MuiDialog-root").css("display","block");
      iframeDoc.querySelector("#modal-title1 button[aria-label='close']").style.color="#fff";
      clearInterval(marketing_index);
      return;
    }
  } catch (e) {}
}, 1000);
var is_success_img = 0;
var success_marketing_index = setInterval(function () {
  try {
    let iframeDoc1 = document.getElementById("automizely_marketing_popup_bars").contentDocument;
    if (iframeDoc1.querySelector("#modal-content2")) {
      iframeDoc1.querySelector("button[aria-label='close']").style.color="#fff";
      clearInterval(success_marketing_index);
      return;
    }
  } catch (e) {
  }
}, 1000);

var coupon_marketing_index = setInterval(function () {
  try {
    let iframeDoc3 = document.getElementById("automizely_marketing_popup_bars").contentDocument;
    if (iframeDoc3.querySelector(".jss1")) {
      iframeDoc3.querySelector("button[aria-label='close']").style.color="#fff";
      iframeDoc3.querySelector(".MuiButtonBase-root svg").style.fontSize="2rem";
      clearInterval(coupon_marketing_index);
      return;
    }
  } catch (e) {
  }
}, 1000);
